import { BookOpen, Heart, Lightbulb, Users, Globe } from "lucide-react";

const values = [
  { icon: Heart, name: "Transmission", desc: "Faire vivre et circuler les idées, les histoires, les convictions." },
  { icon: Lightbulb, name: "Réflexion", desc: "Offrir aux lecteurs des ouvrages qui questionnent et éclairent." },
  { icon: BookOpen, name: "Inspiration", desc: "Éveiller le désir de comprendre, d'agir, de se transformer." },
  { icon: Users, name: "Humanité", desc: "Placer la personne, sa dignité et son cheminement au cœur de tout." },
  { icon: Globe, name: "Accessibilité", desc: "Rendre les livres disponibles partout, simplement, sans barrière." },
];

export default function Author() {
  return (
    <div className="max-w-5xl mx-auto px-6 lg:px-10 py-16 fade-in">
      {/* Hero */}
      <div className="max-w-3xl">
        <div className="label-eyebrow text-accent mb-3">À propos</div>
        <h1 className="font-serif text-5xl md:text-6xl tracking-tight leading-[1.05]">BARON BOOKS</h1>
        <p className="mt-6 text-lg text-muted-foreground leading-relaxed italic">
          « Des histoires qui éveillent, inspirent et transforment. »
        </p>
      </div>

      {/* À propos de BARON BOOKS */}
      <section className="mt-20 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-4">
          <div className="label-eyebrow text-accent">01 — La maison</div>
          <h2 className="mt-3 font-serif text-3xl tracking-tight">À propos de BARON BOOKS</h2>
        </div>
        <div className="md:col-span-8 text-muted-foreground leading-relaxed space-y-4">
          <p>
            BARON BOOKS est une librairie numérique indépendante dédiée à la diffusion des ouvrages de Baron Vincent de Paul. Pensée comme un lieu éditorial simple, moderne et respectueux du lecteur, elle rend accessibles des livres qui ont pour vocation de faire réfléchir, de toucher et d'accompagner.
          </p>
          <p>
            Chaque livre est disponible directement, sans intermédiaire, avec une expérience de lecture soignée sur tous les appareils.
          </p>
        </div>
      </section>

      {/* L'auteur */}
      <section className="mt-20 grid grid-cols-1 md:grid-cols-12 gap-10 items-start">
        <div className="md:col-span-4">
          <div className="label-eyebrow text-accent">02 — La plume</div>
          <h2 className="mt-3 font-serif text-3xl tracking-tight">L'auteur</h2>
        </div>
        <div className="md:col-span-8 text-muted-foreground leading-relaxed space-y-4">
          <p>
            <span className="text-foreground font-medium">Baron Vincent de Paul</span> est écrivain, théologien et conférencier. À travers ses ouvrages, il aborde avec rigueur et sensibilité de grandes questions humaines : la place de la femme, le sens du pouvoir, la souffrance et la restauration.
          </p>
          <p>
            Ses livres — <em>Le fauteuil du chef</em>, <em>Femme dans toutes ses dimensions</em>, <em>Les cris d'une femme</em> — sont autant d'invitations à penser autrement.
          </p>
        </div>
      </section>

      {/* Mission */}
      <section className="mt-20 p-10 md:p-16 border border-border bg-secondary/40">
        <div className="label-eyebrow text-accent">03 — Notre mission</div>
        <p className="mt-6 font-serif text-2xl md:text-3xl leading-relaxed tracking-tight text-balance">
          BARON BOOKS a pour vocation de rendre les œuvres de Baron Vincent de Paul accessibles aux lecteurs, où qu'ils se trouvent, grâce à une expérience de lecture et d'achat simple, moderne et accessible.
        </p>
      </section>

      {/* Valeurs */}
      <section className="mt-20">
        <div className="label-eyebrow text-accent">04 — Nos valeurs</div>
        <h2 className="mt-3 font-serif text-3xl md:text-4xl tracking-tight">Ce qui nous guide</h2>
        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {values.map((v) => (
            <div key={v.name} data-testid={`value-${v.name.toLowerCase()}`} className="p-8 border border-border">
              <v.icon className="w-5 h-5 text-accent" />
              <div className="mt-4 font-serif text-xl">{v.name}</div>
              <p className="mt-2 text-sm text-muted-foreground leading-relaxed">{v.desc}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
